var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"user-chip"},[_c('VAvatar',{attrs:{"size":"32"}},[_c('VImg',{staticClass:"avatar",attrs:{"src":_setup.getAvatar(_vm.user.avatar, 64)}})],1),_c('span',{staticClass:"dancer-name"},[_vm._v(_vm._s(_vm.user.dancerName))]),_vm._t("actions")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }